import { render, staticRenderFns } from "./fromAndSubmit.vue?vue&type=template&id=a1801d3e&scoped=true&"
import script from "./fromAndSubmit.vue?vue&type=script&lang=js&"
export * from "./fromAndSubmit.vue?vue&type=script&lang=js&"
import style0 from "./fromAndSubmit.vue?vue&type=style&index=0&id=a1801d3e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1801d3e",
  null
  
)

export default component.exports